import createVueComponent from '../createVueComponent';
var Hand = createVueComponent('HandIcon', [['path', {
  d: 'M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0',
  key: 'aigmz7'
}], ['path', {
  d: 'M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2',
  key: '1n6bmn'
}], ['path', {
  d: 'M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8',
  key: 'a9iiix'
}], ['path', {
  d: 'M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15',
  key: '1s1gnw'
}]]);
export default Hand;